module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu-item-set"
  }, [_vm._v(_vm._s(_vm.$t('m.cdlmsz')))]), _vm._v(" "), _c('div', {
    staticClass: "xtable"
  }, [_c('div', {
    staticClass: "twui-body-left"
  }, [_c('el-tree', {
    key: "dev-tree",
    ref: "tree",
    staticClass: "tw-tree xsmall",
    attrs: {
      "node-key": "id",
      "highlight-current": "",
      "data": _vm.devTreeData,
      "props": _vm.devTreeDefaultProps,
      "indent": 8,
      "default-expanded-keys": _vm.devTreeExpandedKeys,
      "expand-on-click-node": false
    },
    on: {
      "node-click": _vm.setMenuInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "twui-body-space"
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-body-right"
  }, [_c('div', {
    staticClass: "xpadding-menuchange"
  }, [(!_vm.newflag) ? _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.menuName'),
      "prop": "menuName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.canSave
    },
    model: {
      value: (_vm.ruleForm.menuName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "menuName", $$v)
      },
      expression: "ruleForm.menuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.superior'),
      "prop": "region"
    }
  }, [_c('el-select', {
    staticClass: "xselect-width",
    attrs: {
      "disabled": !_vm.canSave,
      "placeholder": _vm.$t('m.selectTop')
    },
    model: {
      value: (_vm.ruleForm.parentMenuId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "parentMenuId", $$v)
      },
      expression: "ruleForm.parentMenuId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('m.nothing'),
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.devTreeData), function(item) {
    return _c('el-option', {
      key: item.menuId,
      attrs: {
        "label": item.menuName,
        "value": item.menuId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.sortNum'),
      "prop": "sortNum"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.canSave
    },
    model: {
      value: (_vm.ruleForm.sortNum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sortNum", $$v)
      },
      expression: "ruleForm.sortNum"
    }
  })], 1), _vm._v(" "), (_vm.canSave) ? _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', [_vm._v(_vm._s(_vm.$t('m.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateDocMenu
    }
  }, [_vm._v(_vm._s(_vm.$t('m.save')))])], 1) : _vm._e()], 1) : _c('el-form', {
    ref: "newForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.menuName'),
      "prop": "menuName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newForm.menuName),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "menuName", $$v)
      },
      expression: "newForm.menuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.superior'),
      "prop": "region"
    }
  }, [_c('el-select', {
    staticClass: "xselect-width",
    attrs: {
      "placeholder": _vm.$t('m.selectTop'),
      "disabled": ""
    },
    model: {
      value: (_vm.newForm.region),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "region", $$v)
      },
      expression: "newForm.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('m.nothing'),
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.devTreeData), function(item) {
    return _c('el-option', {
      key: item.menuId,
      attrs: {
        "label": item.menuName,
        "value": item.menuId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.sortNum'),
      "prop": "sortNum"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newForm.sortNum),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "sortNum", $$v)
      },
      expression: "newForm.sortNum"
    }
  })], 1), _vm._v(" "), (_vm.newflag) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.appType'),
      "prop": "appType"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.newForm.appType),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "appType", $$v)
      },
      expression: "newForm.appType"
    }
  }, _vm._l((_vm.appTypes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.newflag = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('m.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDocument
    }
  }, [_vm._v(_vm._s(_vm.$t('m.add')))])], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-854ff1a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/web/doc/document-menu.vue
// module id = 599
// module chunks = 1